import { useEffect, useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { QRCodeCanvas } from "qrcode.react";
import { QrCode, Loader2, Download } from "lucide-react";
import { toast } from "sonner";

function QRCard({ title, desc, value, testid }) {
  const ref = useRef(null);
  const dl = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qr-${testid}.png`;
    a.click();
  };
  if (!value) return (
    <div className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`qr-${testid}`}>
      <h3 className="font-heading font-semibold text-slate-900 text-sm">{title}</h3>
      <p className="text-xs text-slate-400 mt-2">Configuration nécessaire — renseignez le lien correspondant dans vos paramètres.</p>
    </div>
  );
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 flex flex-col items-center text-center" data-testid={`qr-${testid}`}>
      <h3 className="font-heading font-semibold text-slate-900 text-sm mb-1">{title}</h3>
      <p className="text-xs text-slate-400 mb-3">{desc}</p>
      <div ref={ref} className="bg-white p-2 rounded-lg border border-slate-100"><QRCodeCanvas value={value} size={160} includeMargin /></div>
      <a href={value} target="_blank" rel="noreferrer" className="text-[11px] text-emerald-600 mt-2 break-all hover:underline">{value}</a>
      <Button size="sm" variant="outline" onClick={dl} data-testid={`qr-dl-${testid}`} className="border-slate-200 mt-3"><Download className="w-3.5 h-3.5 mr-1" /> Télécharger</Button>
    </div>
  );
}

export default function QRCodes() {
  const [links, setLinks] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { try { setLinks((await api.get("/qr-links")).data); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setLoading(false); } })(); }, []);
  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>;
  return (
    <div>
      <PageHeader title="QR codes" subtitle="Affichez, téléchargez et imprimez vos QR codes — chacun pointe vers votre espace." icon={QrCode} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <QRCard title="Réservation en ligne" desc="Vos clients réservent directement" value={links?.booking} testid="booking" />
        <QRCard title="Demande de devis" desc="Formulaire public avec photos" value={links?.quote} testid="quote" />
        <QRCard title="Catalogue public" desc="Vos prestations visibles" value={links?.catalog} testid="catalog" />
        <QRCard title="Avis client" desc="Lien d'avis Google (Paramètres)" value={links?.review} testid="review" />
      </div>
      <p className="text-xs text-slate-400 mt-4">L'espace client est personnel à chaque client (lien sécurisé par jeton généré depuis la fiche client).</p>
    </div>
  );
}
